import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'pcp-auto-size-icon',
  templateUrl: './auto-size-icon.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./auto-size-icon.component.scss'],
  imports: [MatIcon]
})
export class AutoSizeIconComponent implements OnInit, OnDestroy {
  constructor() {}

  private observer: MutationObserver | null = null;

  @Input() svgIcon = '';
  @Input() color: string | null = null;

  @ViewChild('icon', { read: ElementRef, static: true })
  set icon(icon: ElementRef) {
    if (!icon) {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      return;
    }
    if (!this.applyViewBox(icon)) {
      this.observer = new MutationObserver(() => {
        this.applyViewBox(icon);
      });
      this.observer.observe(icon.nativeElement as HTMLElement, {
        childList: true
      });
    }
  }

  applyViewBox(icon: ElementRef) {
    if ((icon.nativeElement as HTMLElement).children.length === 1) {
      (icon.nativeElement as HTMLElement).children[0].setAttribute(
        'viewBox',
        '0 0 24 24'
      );
      return true;
    }
    return false;
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
